import { isDefined } from '../ramda';
import { isWYSIWYGStructureDefined } from './isWYSIWYGStructureDefined';
import { IDesc } from './types';

/**
 * Checks whether Text block data is defined or it's empty
 * @param blockData - Text block data
 * @returns {*|boolean}
 */
export function isTextBlockDefined(blockData?: IDesc | string | null) {
  if (!blockData) {
    return false;
  }

  if (typeof blockData === 'string') {
    return isDefined(blockData);
  }

  const isTextFieldDefined = isDefined(blockData?.text);
  const isWYSIWYGDefined = isWYSIWYGStructureDefined(blockData?.raw);

  return isTextFieldDefined || isWYSIWYGDefined;
}
